module.exports = __webpack_public_path__ + "static/img/Sams_wolf.c70e3c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sams_wolf.png
// module id = /X0X
// module chunks = 1